module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-formulaire-qualif-2.80717aa6.png";